import { useState, useEffect, Fragment } from "react";

// @mui material components
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Custom styles for the Configurator
import ConfiguratorRoot from "examples/Configurator/ConfiguratorRoot";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setOpenConfigurator,
  setTransparentSidenav,
  setWhiteSidenav,
  setSidenavColor,
} from "context";
import { deleteNotification, getNotification } from "../../api/routes";
import { toast } from "react-toastify";

function Configurator({ setNotificationCount }) {
  const [controller, dispatch] = useMaterialUIController();
  const {
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [disabled, setDisabled] = useState(false);
  const sidenavColors = ["primary", "dark", "info", "success", "warning", "error"];
  const [notification, setNotification] = useState([]);
  // Use the useEffect hook to change the button state for the sidenav type based on window size.
  useEffect(() => {
    // A function that sets the disabled state of the buttons for the sidenav type.
    function handleDisabled() {
      return window.innerWidth > 1200 ? setDisabled(false) : setDisabled(true);
    }

    // The event listener that's calling the handleDisabled function when resizing the window.
    window.addEventListener("resize", handleDisabled);

    // Call the handleDisabled function to set the state with the initial value.
    handleDisabled();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleDisabled);
  }, []);

  // useEffect(() => {
  //   if (localStorage.getItem("x-auth-token")) {
  //     getNotification((isOk, data) => {
  //       if (!isOk) {
  //         return alert(data.message);
  //       } else {
  //         setNotificationCount(data.length);
  //         setNotification(data);
  //       }
  //     });
  //   }
  // }, [localStorage.getItem("x-auth-token")]);
  const deleteNotificationHandler = (notificationId) => {
    deleteNotification(notificationId, (isOk, data) => {
      if (!isOk) {
        return toast.error(data.message);
      } else {
        window.location.reload();
      }
    });
  };
  const handleCloseConfigurator = () => setOpenConfigurator(dispatch, false);
  const handleTransparentSidenav = () => {
    setTransparentSidenav(dispatch, true);
    setWhiteSidenav(dispatch, false);
  };
  const handleWhiteSidenav = () => {
    setWhiteSidenav(dispatch, true);
    setTransparentSidenav(dispatch, false);
  };
  const handleDarkSidenav = () => {
    setWhiteSidenav(dispatch, false);
    setTransparentSidenav(dispatch, false);
  };
  /*   const handleDarkMode = () => setDarkMode(dispatch, !darkMode);
   */
  // sidenav type buttons styles
  const sidenavTypeButtonsStyles = ({
                                      functions: { pxToRem },
                                      palette: { white, dark, background },
                                      borders: { borderWidth },
                                    }) => ({
    height: pxToRem(39),
    background: darkMode ? background.sidenav : white.main,
    color: darkMode ? white.main : dark.main,
    border: `${borderWidth[1]} solid ${darkMode ? white.main : dark.main}`,

    "&:hover, &:focus, &:focus:not(:hover)": {
      background: darkMode ? background.sidenav : white.main,
      color: darkMode ? white.main : dark.main,
      border: `${borderWidth[1]} solid ${darkMode ? white.main : dark.main}`,
    },
  });

  // sidenav type active button styles
  const sidenavTypeActiveButtonStyles = ({
                                           functions: { pxToRem, linearGradient },
                                           palette: { white, gradients, background },
                                         }) => ({
    height: pxToRem(39),
    background: darkMode ? white.main : linearGradient(gradients.dark.main, gradients.dark.state),
    color: darkMode ? background.sidenav : white.main,

    "&:hover, &:focus, &:focus:not(:hover)": {
      background: darkMode ? white.main : linearGradient(gradients.dark.main, gradients.dark.state),
      color: darkMode ? background.sidenav : white.main,
    },
  });

  return (
    <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={4}
        pb={0.5}
        px={3}
      >

        <MDBox>
          <MDTypography variant="h5">نوتیفیکیشن</MDTypography>
        </MDBox>

        <Icon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: darkMode ? white.main : dark.main,
            stroke: "currentColor",
            strokeWidth: "2px",
            cursor: "pointer",
            transform: "translateY(5px)",
          })}
          onClick={handleCloseConfigurator}
        >
          close
        </Icon>
      </MDBox>

      <Divider />

      <MDBox pt={0.5} pb={3} px={3}>
        {notification.map(item =>
          <Fragment key={item.id}>
            <MDBox style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
              <section style={{ width: "90%" }}>
                <p style={{ fontSize: 14, whiteSpace: "break-spaces" }}>{item.message}</p>
                <p style={{
                  fontSize: 11,
                  whiteSpace: "break-spaces",
                }}>{item.createdAt.slice(8, 10)}:{item.createdAt.slice(10, 12)}:{item.createdAt.slice(12, 14)} - {item.createdAt.slice(0, 4)}/{item.createdAt.slice(4, 6)}/{item.createdAt.slice(6, 8)}</p>
              </section>
              <Icon sx={{ color: "red", cursor: "pointer" }}
                    onClick={() => deleteNotificationHandler(item.id)}>delete</Icon>
            </MDBox>
            <Divider />
          </Fragment>,
        )}

      </MDBox>
    </ConfiguratorRoot>);
}

export default Configurator;
